import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/joinBenefit/icon1_01.png'
import _imports_1 from '@/assets/joinBenefit/icon1_02.png'
import _imports_2 from '@/assets/joinBenefit/icon1_03.png'
import _imports_3 from '@/assets/joinBenefit/icon1_04.png'
import _imports_4 from '@/assets/joinBenefit/pic2_01.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>企業文化與福利</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><p>和平電廠作為台泥企業團子公司，秉持集團企業理念與多元 Diversity、平等 Equity、共融 Inclusion 精神，以員工需求為優先，透過「性別平權、世代共融、種族包容」三大主軸正視企業人才結構議題，推動以人為本企業文化，營造公正且充滿活力的友善職場。</p><p>我們重視跨代共融，員工的多元性、尊重及接納個體差異，並積極促進不同世代的溝通協作，建立和諧健康的工作環境。</p><a target=\"_blank\" href=\"https://www.104.com.tw/company/7e7nehs?jobsource=google\">→ 了解和電最新工作機會</a><div class=\"gallery\"><div class=\"imgContainer imgContainer1-1\"><div class=\"tit\"><div class=\"icon\"><img src=\"" + _imports_0 + "\"></div><div class=\"name\">和電龍舟隊</div></div></div><div class=\"imgContainer imgContainer1-2\"><div class=\"tit\"><div class=\"icon\"><img src=\"" + _imports_1 + "\"></div><div class=\"name\">社團活動</div></div></div><div class=\"imgContainer imgContainer1-3\"><div class=\"tit\"><div class=\"icon\"><img src=\"" + _imports_2 + "\"></div><div class=\"name\">單車環島挑戰</div></div></div><div class=\"imgContainer imgContainer1-4\"><div class=\"tit\"><div class=\"icon\"><img src=\"" + _imports_3 + "\"></div><div class=\"name\">歌唱大賽</div></div></div></div><div class=\"sectTit\">員工持股信託</div><p>同仁由每月薪資中提撥固定金額，同時公司也相對提撥 1:1 公提金共同存至專用信託專戶，並提供已參與之同仁每年 6 月、12 月申請單筆持股信託增額同享方案，同時陪存自提金之 10% 至個人信託帳戶。此外，屆齡 60 歲退休的台泥夥伴更可加乘提撥，不僅達到留才目的，更協助同仁累積財富，規劃未來退休生活。2023 年參與率 95.43%。</p></div></section>", 2)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "有薪志工假", -1)
const _hoisted_6 = { class: "volunteer" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_9 = {
  class: "info",
  ref: "info"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"block1\"><span class=\"year\">2024</span> 年<br>申請人次</div><div class=\"block2\"><span class=\"num1\">47</span> 人/共 <span class=\"num2\">200</span> 小時</div>", 2)
const _hoisted_12 = [
  _hoisted_10
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, " 2018 年 9 月，台泥企業團正式推出「有薪志工假」，鼓勵同仁工作之餘踴躍投入公益服務、回饋社會。台泥也與外部慈善協會合作，不定期於各營運據點所在縣市舉辦多元志工活動，並開設志工基礎訓練課程，依照衛生福利部指引，協助同仁了解志願服務內涵與倫理、服務經驗分享及相關法規，透過關懷長者與弱勢族群、共同製作春節禮盒或水泥手作、協助居家修繕等，攜手同仁開創職場以外對社會的多元投入。 ", -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<br><div class=\"gallery\"><div class=\"left\"><div class=\"imgContainer2-1\"></div></div><div class=\"right\"><div class=\"imgContainer2-2\"></div></div></div>", 2)
const _hoisted_16 = { class: "sect3" }
const _hoisted_17 = { class: "ctx" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "和平電力員工福利", -1)
const _hoisted_19 = { class: "benefit" }
const _hoisted_20 = { class: "left" }
const _hoisted_21 = {
  key: 0,
  class: "item"
}
const _hoisted_22 = { class: "icon" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "tit" }
const _hoisted_25 = { class: "bList" }
const _hoisted_26 = { class: "note" }
const _hoisted_27 = { class: "right" }
const _hoisted_28 = {
  key: 0,
  class: "item"
}
const _hoisted_29 = { class: "icon" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "tit" }
const _hoisted_32 = { class: "bList" }
const _hoisted_33 = { class: "note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _hoisted_12, 512)
            ]),
            _hoisted_13
          ]),
          _hoisted_14
        ])
      ]),
      _createElementVNode("section", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefit, (row, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                  (idx<6)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("img", {
                            src: _ctx.getBenefitIcon(row.icon)
                          }, null, 8, _hoisted_23),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(row.tit), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.bList, (row2, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                              _createElementVNode("div", null, _toDisplayString(row2.txt), 1),
                              _createElementVNode("div", _hoisted_26, _toDisplayString(row2.note), 1)
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefit, (row, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                  (idx==6)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("img", {
                            src: _ctx.getBenefitIcon(row.icon)
                          }, null, 8, _hoisted_30),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(row.tit), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.bList, (row2, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                              _createElementVNode("div", null, _toDisplayString(row2.txt), 1),
                              _createElementVNode("div", _hoisted_33, _toDisplayString(row2.note), 1)
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}